const binding = { modules: {}, dataActions: {} };

    (binding.modules['vinhuset-product-specification-tab'] = {
        c: () => require('partner/modules/vinhuset-product-specification-tab/vinhuset-product-specification-tab.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'vinhuset-product-specification-tab',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/vinhuset-product-specification-tab'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };